module.exports = __webpack_public_path__ + "media/moron.95196aae.mp3";